// eslint-disable-next-line import/prefer-default-export
import { DOCUMENT_COMPONENT_TYPES } from "../../constants/document";

export const DOCUMENTVIEW_MODE = {
  DOCUMENTVIEW: "DOCUMENT",
  FORMVIEW: "FORM_VIEW",
};

export const DOCUMENT_BLOCKS = {
  COVERPAGE: "COVERPAGE",
  HEADER: "HEADER",
  FOOTER: "FOOTER",
  HEADER_FOOTER: "HEADER_FOOTER",
  BODY: "BODY",
};

export const ALLOW_COMPONENT_DRAG = {
  OUTLINE: "OUTLINE",
  DOCUMENT: "DOCUMENT",
  ADD_COMPONENTS: "ADD_COMPONENTS",
};

export const ADD_COMPONENT_ALLOWED = {
  COVERPAGE: [
    DOCUMENT_COMPONENT_TYPES.HTML,
    DOCUMENT_COMPONENT_TYPES.TABLE,
    DOCUMENT_COMPONENT_TYPES.IMAGE,
    DOCUMENT_COMPONENT_TYPES.LINE_SPACE,
  ],
  HEADER: [
    DOCUMENT_COMPONENT_TYPES.HTML,
    DOCUMENT_COMPONENT_TYPES.TABLE,
    DOCUMENT_COMPONENT_TYPES.IMAGE,
    DOCUMENT_COMPONENT_TYPES.LINE_SPACE,
  ],
  FOOTER: [
    DOCUMENT_COMPONENT_TYPES.HTML,
    DOCUMENT_COMPONENT_TYPES.TABLE,
    DOCUMENT_COMPONENT_TYPES.IMAGE,
    DOCUMENT_COMPONENT_TYPES.LINE_SPACE,
  ],
  HEADER_FOOTER: [
    DOCUMENT_COMPONENT_TYPES.HTML,
    DOCUMENT_COMPONENT_TYPES.TABLE,
    DOCUMENT_COMPONENT_TYPES.IMAGE,
    DOCUMENT_COMPONENT_TYPES.LINE_SPACE,
  ],
  BODY: [
    DOCUMENT_COMPONENT_TYPES.HTML,
    DOCUMENT_COMPONENT_TYPES.TABLE,
    DOCUMENT_COMPONENT_TYPES.IMAGE,
    DOCUMENT_COMPONENT_TYPES.DEAL_TABLE,
    DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE,
    DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER,
    DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER,
    DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET,
    DOCUMENT_COMPONENT_TYPES.PAGE_BREAK,
    DOCUMENT_COMPONENT_TYPES.LINE_SPACE,
    DOCUMENT_COMPONENT_TYPES.STRIPE_PAYMENT_BUTTON,
  ],
};



// WEBPACK FOOTER //
// ./src/components/DocumentV2/constants.js